// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const orthworm: PokeData = {
  "id": 968,
  "name": "orthworm",
  "height": 25,
  "weight": 3100,
  "base_experience": 240,
  "types": [
    PokeType.STEEL
  ],
  "api_moves": [
    "tackle",
    "wrap",
    "take-down",
    "earthquake",
    "dig",
    "harden",
    "mud-slap",
    "sandstorm",
    "iron-tail",
    "iron-defense",
    "iron-head",
    "smack-down",
    "bulldoze",
    "shed-tail"
  ],
  "moves": [
    "tackle",
    "earthquake",
    "mud-slap",
    "sandstorm",
    "metal-burst",
    "behemoth-bash",
    "magnet-pull",
    "smart-strike",
    "metal-claw",
    "scrap-throw",
    "magnet-bomb",
    "gear-up",
    "steel-beam"
  ],
  "evolution_chain": {
    "id": 507,
    "item": null,
    "species": [
      {
        "name": "orthworm",
        "order": 944,
        "types": [
          PokeType.STEEL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 145,
    "speed": 111,
    "ability_power": 145
  },
  "stat_changes": [],
  "catch_rate": 25,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
